module.exports = __webpack_public_path__ + "nc_static/media/download.cca54cd8.svg";